import * as React from 'react';
import { forgeClassHelper } from '../utils/classes';
import ListItem, { ListItemProps } from '../ListItem';

const classes = forgeClassHelper('interactive-list');

export interface InteractiveListItemProps extends ListItemProps {
  className?: string;
  active?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLLIElement>;
  uniqueKey: string;
}

/**
 * InteractiveListItem
 *
 * A component to render an unordered list item.
 *
 */
function InteractiveListItem({
  uniqueKey,
  active = false,
  disabled = false,
  ...rootProps
}: InteractiveListItemProps): JSX.Element {
  const states = [];
  const itemProps = {
    'data-key': uniqueKey,
    ...rootProps,
  };

  if (active) {
    states.push('active');
  }

  if (disabled) {
    states.push('disabled');
    itemProps['aria-disabled'] = true;
    itemProps.onClick = (event) => {
      // Disabled items should not trigger events in the parent on click.
      // Rather than having the parent track all that, we simply stop
      // propagation here.
      // This is only necessary because we are using the <Checkbox /> component,
      // instead of <input type="checkbox" />. The <label> of <Checkbox /> is not
      // disabled, and thus this event can fire on a disabled item.
      event.stopPropagation();
    };
  }

  const classNames = classes({
    extra: itemProps.className,
    element: 'item',
    states: states,
  });

  return <ListItem {...itemProps} {...classNames} />;
}

export default InteractiveListItem;
